module.exports = __webpack_public_path__ + "img/00038.48f20e9e.webp";